import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

const apiBase = import.meta.env.VITE_API_BASE;

interface Candidate {
    id: string;
    email: string;
    fullName: string | null;
    invitedBy?: string;
    createdAt?: string;
    role: string;
}

export default function CandidatesList() {
    const { role, user } = useAuth();
    const [candidates, setCandidates] = useState<Candidate[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (role !== "ExamAdmin") return;

        const fetchCandidates = async () => {
            setLoading(true);

            try {
                const token =
                    localStorage.getItem("authToken") ||
                    sessionStorage.getItem("authToken");

                const res = await fetch(
                    `${apiBase}/api/candidates?invitedBy=${user?.id || ""}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (!res.ok) {
                    throw new Error(await res.text());
                }

                const data = await res.json();
                setCandidates(data || []);
            } catch (err) {
                console.error("Error fetching candidates:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchCandidates();
    }, [role, user]);

    if (role !== "ExamAdmin") {
        return <p className="text-red-600">❌ Access denied.</p>;
    }

    return (
        <div className="bg-white p-6 rounded-xl shadow">
            <h2 className="text-xl font-bold mb-4">Invited Candidates</h2>

            {loading ? (
                <p>Loading...</p>
            ) : candidates.length === 0 ? (
                <p className="text-gray-600">No candidates invited yet.</p>
            ) : (
                <table className="w-full border text-sm">
                    <thead>
                        <tr className="bg-gray-50 text-left">
                            <th className="p-2 border">Email</th>
                            <th className="p-2 border">Full Name</th>
                            <th className="p-2 border">Invited</th>
                            <th className="p-2 border">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {candidates.map((c) => (
                            <tr key={c.id}>
                                <td className="p-2 border">{c.email}</td>
                                <td className="p-2 border">{c.fullName || "-"}</td>
                                <td className="p-2 border">
                                    {c.createdAt
                                        ? new Date(c.createdAt).toLocaleDateString()
                                        : "-"}
                                </td>
                                <td className="p-2 border">
                                    {c.fullName ? "✅ Active" : "⏳ Pending"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}
